import { forwardRef } from 'react';
import c from 'classnames';

import { ChevronDown } from '@lyearn/icons';
import { BaseButton } from '@lyearn/ui';

import { popupButtonAdornmentStyles, popupButtonFocusStyles } from './styles';
import { PopupButtonProps } from './types';

const POPUP_BUTTON_SHAPE_CLASSES = {
  pill: 'px-12 rounded-full',
  square: 'px-10 rounded-8',
};

const PopupButton = forwardRef<HTMLButtonElement, PopupButtonProps>((props, ref) => {
  const { className, shape = 'square', chevron, endIcon: endIconProp, ...rest } = props;

  const shapeClassName = POPUP_BUTTON_SHAPE_CLASSES[shape];
  const endIcon = chevron ? <ChevronDown className="h-16 w-16 text-icon-secondary" /> : endIconProp;

  return (
    <BaseButton
      ref={ref}
      className={c(
        'body-short-02 h-32 border border-solid border-border bg-bg-primary text-text-secondary hover:bg-bg-hover active:bg-bg-onclick',
        shapeClassName,
        popupButtonFocusStyles,
        popupButtonAdornmentStyles,
        className,
      )}
      endIcon={endIcon}
      {...rest}
    />
  );
});

export default PopupButton;
